// ======================================================
// 🔧 CONFIGURACIÓN GLOBAL Y UTILIDADES REUTILIZABLES
// ======================================================


  // 🔁 Token para evitar cargas múltiples de íconos

  let currentIconLoadToken = 0;
  let lastLoaderScreenPosition = null;
  let lastCustomIconPosition = null;


  // 🌐 Configuración global reutilizable

  const IMPRINTLY = {
    canvasLimits: {
      minPercent: 0, // Minimo del grupo
      maxPercent: 20, // Maximo del grupo
      tolerance: 0 // Rango de tolerancia para llegar al limite y se pinte la linea roja.
    },
    movementBounds: {
      leftPercent: 0,
      rightPercent: 100,
      topPercent: 0,
      bottomPercent: 100
    },
    borderColors: {
      default: '#bfd4fe',
      alert: '#D70040'
    },
    defaults: {
      font: 'Block',
      color: 'Black'
    },
    canvasTypes: {
      TEXT: 'personalizedText',
      GROUP: 'personalizedGroup'
    },
    iconDefaults: {
      iconScalePercent: 8,       // Porcentaje del ancho del canvas (ej. 8%)
      iconGapPercent: 2.5,       // Separación horizontal entre 2 íconos 
      iconMarginTopPercent: 3  // Separación vertical respecto al texto
    },
    tabConfigs: {
      'imprintly-tab-1': {
        alias: 'MONOGRAM',
        scalingMode: 'auto-width',  // 'fit-box' = Caja con tamaño fijo, 'auto-width' = Caja dinamica según el contenido.
        allowScaling: false,
        allowMovement: false,
        canvasLimits: {
          maxPercent: parseFloat($('#imprintly-tab-1').attr('data-max-percent'))
        }
      },
      'imprintly-tab-2': {
        alias: 'INITIALS',
        scalingMode: 'auto-width',
        allowScaling: false,
        allowMovement: false,
        iconOverrides: {
          iconMarginTopPercent: 4.5
        },
        canvasLimits: {
          maxPercent: parseFloat($('#imprintly-tab-2').attr('data-max-percent'))
        }
      },
      'imprintly-tab-3': {
        alias: 'NAME',
        scalingMode: 'auto-width',
        allowScaling: false,
        allowMovement: false,
        iconOverrides: {
          iconMarginTopPercent: 4
        },
        canvasLimits: {
          maxPercent: parseFloat($('#imprintly-tab-3').attr('data-max-percent'))
        }
      },
      'imprintly-tab-4': {
        alias: 'ICON',
        scalingMode: 'fit-box',
        allowScaling: false,
        allowMovement: false,
        canvasLimits: {
          maxPercent: parseFloat($('#imprintly-tab-4').attr('data-max-percent'))
        }
      }
    }
  };



  // 🔁 Genera automáticamente el objeto IMPRINTLY.tabs usando los alias definidos en tabConfigs. Esto permite acceder fácilmente a los IDs de tab usando nombres.

  IMPRINTLY.tabs = Object.fromEntries(
    Object.entries(IMPRINTLY.tabConfigs).map(([tabId, config]) => [config.alias, tabId])
  );
  
  
  
  // 🧱 Desactiva todos los controles visuales de un objeto Fabric.js
  
  function disableAllObjectControls(obj, allowScaling = true) {
    obj.setControlsVisibility({
      tl: allowScaling,
      tr: allowScaling,
      br: allowScaling,
      bl: allowScaling,
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      mtr: false
    });
  }
  
  
  
  
  // 🔄 Obtiene todos los valores dinámicos del tab activo: texto, fuente, color, posición, tamaño y tabId. (Reutilizable para renderizar cualquier tipo de personalización.)

  function getActiveTabValues() {
    const $activeTab = $('.imprintly__tab--active');
  
    const $input = $activeTab.find('input[type="text"]');
    const text = $input.length ? ($input.val().trim() || $input.attr('placeholder') || '') : '';
  
    const fontRadio = $activeTab.find('.imprintly__tab-font input[type="radio"]:checked');
    const fontName = fontRadio.val() || IMPRINTLY.defaults.font;
  
    const colorRadio = $activeTab.find('.imprintly__tab-color input[type="radio"]:checked');
    const colorName = colorRadio.val() || IMPRINTLY.defaults.color;
    const hexColor = colorHexMap[colorName] || '#000000';
  
    const { xPercent, yPercent, widthPercent, fontSizePercent } = getCanvasPositionFromTab($activeTab);
  
    return {
      tabId: $activeTab.attr('id'),
      text,
      fontName,
      colorName,
      hexColor,
      xPercent,
      yPercent,
      widthPercent,
      fontSizePercent
    };
  }
  
  
  
  
  // 🔄 Extrae la posición (x, y) y tamaño (ancho y fontSize en %) del tab activo (reutilizable para reposicionar objetos en el canvas)
  
  function getCanvasPositionFromTab(tabElement) {
    const xPercent = parseFloat(tabElement.attr('data-x') || 0);
    const yPercent = parseFloat(tabElement.attr('data-y') || 0);
    const widthPercent = parseFloat(tabElement.attr('data-width') || 100);
    const fontSizePercent = parseFloat(tabElement.attr('data-font-size') || 100);
    return { xPercent, yPercent, widthPercent, fontSizePercent };
  }
  
  
  
  // 🔄 Calcula posición (x, y), ancho (boxWidth) y fontSize (en px) del objeto en base a los datos del tab activo
  
  function getObjectPositionAndScaleFromTab(tabElement, canvasWidth, canvasHeight, useBoxWidthForFontSize = false) {
    const { xPercent, yPercent, widthPercent, fontSizePercent } = getCanvasPositionFromTab(tabElement);
    const x = (xPercent / 100) * canvasWidth;
    const y = (yPercent / 100) * canvasHeight;
    const boxWidth = (widthPercent / 100) * canvasWidth;
  
    const reference = useBoxWidthForFontSize ? boxWidth : canvasWidth;
    const fontSize = (fontSizePercent / 100) * reference;

    const rotation = parseFloat(tabElement.data('rotation')) || 0;
  
    return { x, y, boxWidth, fontSize, rotation };
  }
  
  
  
  
  // 📏 Calcula los límites mínimos y máximos de ancho del objeto según el tamaño del canvas (en píxeles)
  
  function getCanvasWidthLimits(canvasWidth, tabId) {
    const { minPercent, maxPercent } = getCanvasLimitsForTab(tabId);
    return {
      minWidth: (minPercent / 100) * canvasWidth,
      maxWidth: (maxPercent / 100) * canvasWidth
    };
  }
  
  
  
  // 🧩 Aplica los límites de ancho al objeto personalizado (reutilizable para texto, grupo, etc.)
  
  function applyCanvasWidthLimits(obj, canvasWidth, tabId) {

    // console.log('🧩 applyCanvasWidthLimits -> tabId:', tabId, '| alias:', IMPRINTLY.tabConfigs[tabId]?.alias);

    const { tolerance } = IMPRINTLY.canvasLimits;
    const { minWidth, maxWidth } = getCanvasWidthLimits(canvasWidth, tabId);
    const currentWidth = obj.getScaledWidth();
  
    const alias = IMPRINTLY.tabConfigs[tabId]?.alias || '';
  
    const scalingMode = getScalingModeForTab(tabId);
    const isAutoWidth = scalingMode === 'auto-width';

    const applyLimits = alias === 'ICON' || isAutoWidth || obj.userScaled;


    // console.log('📏 applyLimits?', applyLimits, '| alias:', alias, '| userScaled:', obj.userScaled, '| isAutoWidth:', isAutoWidth);


    if (applyLimits) {

      // console.log('✅ Entrando en bloque applyLimits');
      // console.log('  - currentWidth:', currentWidth);
      // console.log('  - minWidth:', minWidth);
      // console.log('  - maxWidth:', maxWidth);


      if (currentWidth < minWidth - tolerance) {
        obj.scaleToWidth(minWidth);
        // console.log('  ⚠️ Escala ajustada por límite mínimo');
      } else if (currentWidth > maxWidth + tolerance) {
        obj.scaleToWidth(maxWidth);
        // console.log('  ⚠️ Escala ajustada por límite máximo');
      }
      updateTextBorderColor(obj, tabId);
      return;
    }

    /*console.log('🔎 Evaluando límites: currentWidth =', currentWidth, 'minWidth =', minWidth, 'maxWidth =', maxWidth);
    console.log('🔎 Evaluando límites:');
    console.log('  - currentWidth:', currentWidth);
    console.log('  - minWidth:', minWidth);
    console.log('  - maxWidth:', maxWidth);
    console.log('  - Dentro de límites?', currentWidth >= minWidth - tolerance && currentWidth <= maxWidth + tolerance);*/

  
    if (currentWidth < minWidth - tolerance || currentWidth > maxWidth + tolerance) {
      if (alias === 'ICON') {
        const baseWidth = obj.width * (obj.scaleX || 1); // tamaño actual real
        const newWidth = Math.min(Math.max(currentWidth, minWidth), maxWidth);
        const scaleFactor = newWidth / baseWidth;

        /*console.log('🧩 Ajuste para ICON');
        console.log('  - baseWidth:', baseWidth);
        console.log('  - currentWidth:', currentWidth);
        console.log('  - newWidth:', newWidth);
        console.log('  - scaleFactor:', scaleFactor);
        console.log('  - scaleX inicial:', obj.scaleX);
        console.log('  - scaleY inicial:', obj.scaleY);*/
      
        obj.scaleX *= scaleFactor;
        obj.scaleY *= scaleFactor;

        // console.log('  - scaleX final:', obj.scaleX);
        // console.log('  - scaleY final:', obj.scaleY);
      
        obj.customScaledWidth = obj.getScaledWidth();
        obj.userScaled = true;
        obj._lastValidScaleX = obj.scaleX;
        obj._lastValidScaleY = obj.scaleY;
      
        finalizeObjectUpdate(obj, tabId);

        // ❗ Extra: verifica si se activa otra vez después de esto
        /*setTimeout(() => {
          console.log('  [Post ajuste] Width actual:', obj.getScaledWidth());
          console.log('  [Post ajuste] Dentro de límites?', obj.getScaledWidth() >= minWidth && obj.getScaledWidth() <= maxWidth);
        }, 100);*/

        return;

      } else {
        if (currentWidth < minWidth - tolerance) {
          obj.scaleToWidth(minWidth);
        } else if (currentWidth > maxWidth + tolerance) {
          obj.scaleToWidth(maxWidth);
        }
      }

      // console.log('  ⚠️ Ajustando escala (límite excedido)');
    }

    /*console.log('🧪 [applyCanvasWidthLimits]');
    console.log('  tabId:', tabId);
    console.log('  currentWidth:', currentWidth);
    console.log('  minWidth:', minWidth);
    console.log('  maxWidth:', maxWidth);
    console.log('  tolerance:', tolerance);
    console.log('  customScaledWidth?', obj.customScaledWidth);
    console.log('  scalingMode:', getScalingModeForTab(tabId));*/


  }
  
  
  
  
  // 🔍 Devuelve el objeto personalizado del canvas (text o grupo), si existe
  
  function getPersonalizedObject(tabId = null) {
    const validTypes = Object.values(IMPRINTLY.canvasTypes);
    return fabricCanvas.getObjects().find(obj =>
      validTypes.includes(obj.customType) &&
      (!tabId || obj.tabId === tabId)
    ) || null;
  }



  // 🔍 Devuelve el modo de escalado configurado para el tab activo ('fit-box' o 'auto-width'). // Si no se define, el valor por defecto es 'fit-box'.

  function getScalingModeForTab(tabId) {
    return IMPRINTLY.tabConfigs[tabId]?.scalingMode || 'fit-box';
  }



  // 🔒 Devuelve si el objeto del tab actual permite ser escalado manualmente en el canvas. // Si no se define, el valor por defecto es true (se permite escalar).

  function getAllowScalingForTab(tabId) {
    return IMPRINTLY.tabConfigs[tabId]?.allowScaling ?? true;
  }
  


  // Ajusta visualmente el fontSize según cantidad de letras, fuente y tipo de tab, compatible con fit-box y auto-width

  function adjustFontSizeByCharCount(tabId, text, baseFontSize, fontName, scalingMode = 'auto-width') {
    const alias = IMPRINTLY.tabConfigs[tabId]?.alias || '';
    const count = text.length;

    let adjusted = baseFontSize;

    // 🔠 Ajuste por tipo de fuente
    if (fontName) {
      const normalizedFont = fontName.toLowerCase();

      /*
      // 🔠 SOLO FONT
      if (normalizedFont.includes('endevor')) {
        adjusted *= 1.5;
      }

      if (normalizedFont.includes('athletic')) {
        adjusted *= 1.2;
      }

      if (normalizedFont.includes('times')) {
        adjusted *= 1.2;
      }

      if (normalizedFont.includes('contour')) {
        adjusted *= 1.2;
      }

      if (normalizedFont.includes('felt tip')) {
        adjusted *= 1.2;
      }

      if (normalizedFont.includes('felt tip')) {
        adjusted *= 1.2;
      }*/

      // 🔠 FONT + TAP
      /*
      if (normalizedFont.includes('endevor') && alias === 'MONOGRAM') {
        adjusted *= 1.5;
      }*/
      // Puedes agregar más fuentes aquí si lo necesitas
    }

    // 🎯 Ajuste por tab y cantidad de letras
    if (alias === 'MONOGRAM') {
      if (count === 1) adjusted *= 1.0;
      else if (count === 2) adjusted *= 1.0;
      else if (count === 3) adjusted *= 1.0;
    }

    if (alias === 'INITIALS') {
      if (count === 1) adjusted *= 1.0;
      else if (count === 2) adjusted *= 1.0;
    }

    if (alias === 'NAME') {
      if (count === 1) adjusted *= 1.0;
      else if (count === 2) adjusted *= 1.0;
      else if (count === 3) adjusted *= 1.0;
      else if (count === 4) adjusted *= 1.0;
      else if (count === 5) adjusted *= 1.0;
      else if (count === 6) adjusted *= 1.0;
    }
    

    return adjusted;
  }



  // 📏 Devuelve los límites de ancho (min/max) para el canvas según el tab actual. Si el tab no tiene límites personalizados, retorna los valores definidos en IMPRINTLY.canvasLimits.

  function getCanvasLimitsForTab(tabId) {
    const globalLimits = IMPRINTLY.canvasLimits || {};
    const tabLimits = IMPRINTLY.tabConfigs?.[tabId]?.canvasLimits || {};
    
    return {
      minPercent: tabLimits.minPercent ?? globalLimits.minPercent,
      maxPercent: tabLimits.maxPercent ?? globalLimits.maxPercent,
      tolerance: tabLimits.tolerance ?? globalLimits.tolerance
    };
  }
  



  // 🔧 Limita el ancho visual del objeto si excede el máximo permitido (solo en auto-width)

  function enforceAutoWidthLimits(object, canvasWidth, tabId) {
    const limits = getCanvasLimitsForTab(tabId);
  
    const currentWidth = object.getScaledWidth();
    const minWidth = (limits.minPercent / 100) * canvasWidth;
    const maxWidth = (limits.maxPercent / 100) * canvasWidth;
  
    if (currentWidth < minWidth) {
      object.scaleToWidth(minWidth);
    } else if (currentWidth > maxWidth) {
      object.scaleToWidth(maxWidth);
    }
  
    updateTextBorderColor(object, tabId);

  }



  // 🔧 Activa o desactiva el movimiento del box.

  function getAllowMovementForTab(tabId) {
    return IMPRINTLY.tabConfigs[tabId]?.allowMovement ?? true;
  }
  
  



  // 🎨 Mapa de colores que relaciona los nombres con su valor hexadecimal
  
  const colorHexMap = {
    'Black': '#000000',
    'Burgundy': '#800020',
    'Dark Green': '#506e46',
    'Dark Grey': '#656666',
    'Dark Pink': '#c71364',
    'Dark Purple': '#51007e',
    'Denim': '#79a1e3',
    'Electric Blue': '#00adff',
    'Green': '#66c331',
    'Grey': '#939797',
    'Lavander': '#b295dc',
    'Lime': '#8bd427',
    'Light Grey': '#babdc0',
    'Light Pink': '#f5b6e2',
    'Mint': '#66c2c1',
    'Navy Blue': '#0f1840',
    'Neon Green': '#40e645',
    'Neon Orange': '#f47b2b',
    'Neon Pink': '#f536aa',
    'Neon Yellow': '#eaff7c',
    'Orange': '#f36820',
    'Peach': '#f6a192',
    'Pink': '#dd5189',
    'Red': '#b31b39',
    'Royal Blue': '#354399',
    'Tan': '#e8d8c4',
    'Taupe': '#c0b5ab',
    'Turquoise': '#307fb5',
    'White': '#ffffff',
    'Yellow': '#f5e236'
  };
  
  
  
  // 💰 Calcula y actualiza el precio final combinando base + personalización
  
  function updateImprintlyPrice() {
    const basePrice = parseInt($('.imprintly__header .price').data('price'), 10);
    const activeTabPrice = parseInt($('.imprintly__nav-button--active').data('price'), 10) || 0;
  
    // ✅ Validamos si el checkbox está activo en el tab actual
    const $activeTab = $('.imprintly__tab--active');
    const $checkbox = $activeTab.find('.imprintly__icon-checkbox');
    const $iconBlock = $activeTab.find('.imprintly__tab-icons');
    const iconExtra = ($checkbox.is(':checked') ? parseInt($iconBlock.data('price'), 10) : 0) || 0;
  
    const total = basePrice + activeTabPrice + iconExtra;
  
    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(total / 100);

    const formattedDecimal = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(total / 100);    
  
  
    if(GlobalCampaignActive){
      let discountRate = GlobalCampaignDiscount / 100;
      let offertPrice = total * (1 - discountRate);
      
      const formattedOffert = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      }).format(offertPrice / 100);
      
      $('.imprintly__header .price .regular').text(formattedPrice);
      $('.imprintly__header .price .offert').text(formattedOffert);

      $('.imprintly__footer .imprintly__call-to-action button b.regular').text(formattedPrice);
      $('.imprintly__footer .imprintly__call-to-action button b.offert').text(formattedOffert);
    } else {
      $('.imprintly__header .price').text(formattedPrice);
      $('.imprintly__footer .imprintly__call-to-action button b').text(formattedPrice);
    }

    $('#imprintly').attr('data-price',formattedDecimal);
  }
  
  
  
  
  // 🎨 Coloca el nombre del color en el span respectivo (para mostrar el color activo)
  
  function updateColorLabelText() {
    $('.imprintly__tab').each(function () {
      const $tab = $(this);
      const colorInput = $tab.find('.imprintly__tab-color input[type="radio"]:checked');
      const colorName = colorInput.val();
      const $labelSpan = $tab.find('.imprintly__tab-colors-header span');
      if ($labelSpan.length && colorName) {
        $labelSpan.text(colorName);
      }
    });
  }
  
  
  
  // ✍️ Valida si el texto ingresado cumple con las longitudes mínimas y máximas
  
  function validateImprintlyInput() {
    let isValid = true;
  
    $('.imprintly__tab').each(function () {
      const $tab = $(this);
      const isActive = $tab.hasClass('imprintly__tab--active');
  
      if (!isActive) return;
  
      const $input = $tab.find('input[type="text"]');
      const $error = $tab.find('.imprintly__tab-error');
  
      const value = $input.val().trim();
      const min = parseInt($input.attr('minlength'), 10);
      const max = parseInt($input.attr('maxlength'), 10);
  
      if (!value) {
        $error.hide(); // Oculta si está vacío
        isValid = false;
        return;
      }
  
      if (value.length >= min && value.length <= max) {
        $error.hide();
      } else {
        $error.show();
        isValid = false;
      }
    });
  
    return isValid;
  }
  
  
  
  
  
  // ======================================================
  // 🚀 INICIALIZACIÓN DEL MODAL Y EVENTOS PRINCIPALES
  // ======================================================
  
  
  
  // 🔓 Inicializa el modal de personalización al hacer clic, activa los eventos y dibuja el canvas.
  
  $(document).ready(function () {
    
    updateImprintlyPrice();
    
    const $modal = $('#imprintly');
    const $modalContent = $('.imprintly__content');
    
    $('#openImprintly').on('click', function () {
      $modal.fadeIn(300);
      $('body').css('overflow', 'hidden');
      $modalContent.scrollTop(0);
  
      $('.imprintly__nav-button').removeClass('imprintly__nav-button--active');
      $('.imprintly__nav-button').first().addClass('imprintly__nav-button--active');
      $('.imprintly__tab').removeClass('imprintly__tab--active');
      $('.imprintly__tab').first().addClass('imprintly__tab--active');

      const firstTabId = $('.imprintly__tab').first().attr('id');
      resetIconCountUI(firstTabId);
      
      resetImprintlyTabs();
      hideImprintlyAlert();
      updateImprintlyPrice();


      document.fonts.load("1em 'Block'").then(() => {
        initCanvasWithImage();
      });

      setupCanvasEvents();
      initIconCheckboxListeners();
      updateColorLabelText();
    });
    
    $('.imprintly__close, #imprintly').on('click', function (e) {
      if ($(e.target).is('#imprintly') || $(e.target).hasClass('imprintly__close')) {
        hideCanvasLoader();
        $modal.fadeOut(300, function () {
          $('body').css('overflow', 'auto');

          resetImprintlyIconCheckboxes();
        });
      }
    });
    
  });
  
  
  
  // 🔁 Redibuja el canvas si la ventana cambia de tamaño (para mantener escala)
  
  window.addEventListener('resize', () => {
    resizeCanvasToFitContainer();
  });




  // 🔁 Función para taps en productos con 2 iconos

  function initIconTabSwitching(tabId) {
    const alias = IMPRINTLY.tabConfigs[tabId]?.alias?.toLowerCase();
    if (!alias) return;
  
    const container = document.querySelector(`.imprintly__tab-icons-content--${alias}`);
    if (!container) return;
  
    const btn1 = container.querySelector('.imprintly__tab-icons-tap--1');
    const btn2 = container.querySelector('.imprintly__tab-icons-tap--2');
    const tab1 = container.querySelector('.imprintly__tab-icons-container--1');
    const tab2 = container.querySelector('.imprintly__tab-icons-container--2');
  
    if (!btn1 || !btn2 || !tab1 || !tab2) return;
  
    // console.log(`🟡 Activando tabs internos para ${alias}`);
  
    // 🧠 Detecta cuál estaba activo antes (si existe)
    const currentActive = container.querySelector('.imprintly__tab-icons-tap--1.active')
      ? '1'
      : container.querySelector('.imprintly__tab-icons-tap--2.active')
      ? '2'
      : '1'; // fallback al primero si ninguno
  
    // Limpia eventos anteriores para evitar acumulación
    btn1.replaceWith(btn1.cloneNode(true));
    btn2.replaceWith(btn2.cloneNode(true));
  
    const newBtn1 = container.querySelector('.imprintly__tab-icons-tap--1');
    const newBtn2 = container.querySelector('.imprintly__tab-icons-tap--2');
  
    newBtn1.addEventListener('click', () => {
      newBtn1.classList.add('active');
      newBtn2.classList.remove('active');
      $(tab2).hide();
      $(tab1).fadeIn();
    });
  
    newBtn2.addEventListener('click', () => {
      newBtn2.classList.add('active');
      newBtn1.classList.remove('active');
      $(tab1).hide();
      $(tab2).fadeIn();
    });
  
    // 🔁 Restauramos el tab que estaba activo antes
    if (currentActive === '1') {
      newBtn1.click();
    } else {
      newBtn2.click();
    }
  }




 // Función que se ejecuta al cambiar el checkbox de los iconos.

 function initIconCheckboxListeners() {
    $('.imprintly__details').off('change', '.imprintly__icon-checkbox');

    $('.imprintly__details').on('change', '.imprintly__icon-checkbox', function () {
      const $checkbox = $(this);
      const $tab = $checkbox.closest('.imprintly__tab');
      const isChecked = $checkbox.is(':checked');

      const $iconBlock = $tab.find('.imprintly__tab-icons');
      const iconCount = parseInt($iconBlock.data('icons'), 10) || 1;
      const tabId = $tab.attr('id');
      // console.log('🟢 Checkbox cambiado:', { isChecked, iconCount });

      // 🎯 Acceder al data-font-size desde el div.imprintly__tab
      const currentFontSize = parseInt($tab.attr('data-font-size'), 10);
      const originalFontSize = $tab.data('original-font-size') || currentFontSize;

      if (isChecked) {
        // 🔠 Guardar original si aún no existe
        if (!$tab.data('original-font-size')) {
          $tab.attr('data-original-font-size', originalFontSize);
        }

        // 🔠 Reducir 10% (puedes ajustar al gusto)
        const reducedFontSize = Math.round(originalFontSize * 0.9);
        $tab.attr('data-font-size', reducedFontSize);

        // 🔹 Mostrar bloque de íconos
        $iconBlock.find('.imprintly__tab-icons-content').slideDown();
        $iconBlock.find('.imprintly__tab-icons-content input[type="radio"]').prop('checked', false);

        if (iconCount === 1) {
          $iconBlock.find('.imprintly__tab-icons-container .imprintly__tab-icon')
            .first()
            .find('input[type="radio"]')
            .prop('checked', true)
            .trigger('change');
        } else if (iconCount === 2) {
          $iconBlock.find('.imprintly__tab-icons-container--1 .imprintly__tab-icon input[type="radio"]').prop('checked', false);
          $iconBlock.find('.imprintly__tab-icons-container--2 .imprintly__tab-icon input[type="radio"]').prop('checked', false);

          const radio1 = $iconBlock.find('.imprintly__tab-icons-container--1 .imprintly__tab-icon').first().find('input[type="radio"]');
          const radio2 = $iconBlock.find('.imprintly__tab-icons-container--2 .imprintly__tab-icon').first().find('input[type="radio"]');

          radio1.prop('checked', true);
          radio2.prop('checked', true);
          radio2.trigger('change'); // esto redibuja el canvas
        }

      } else {
        
        // 🔹 Restaurar font-size original
        if (originalFontSize) {
          $tab.attr('data-font-size', originalFontSize);
        }

        // 🔹 Ocultar íconos y limpiar selección
        $iconBlock.find('.imprintly__tab-icons-content').slideUp();
        $iconBlock.find('.imprintly__tab-icons-content input[type="radio"]').prop('checked', false);

        if (iconCount === 2) {
          const alias = IMPRINTLY.tabConfigs[tabId]?.alias?.toLowerCase();
          const $container = $(`.imprintly__tab-icons-content--${alias}`);
          if ($container.length) {
            $container.find('.imprintly__tab-icons-tap--1').trigger('click');
          }
        }

        resetIconCountUI(tabId);

        // 🔁 Redibujar con font-size restaurado
        drawCanvasFromActiveTab();
      }

      updateImprintlyPrice();
      // ⚠️ No se llama drawCanvasFromActiveTab aquí si ya lo hace el trigger('change')
    });
  }




  // ✅ Crear grupo texto + íconos debajo si el checkbox está activo
  
  async function createTextWithIconGroup(textObject, tabId, token = null, iconCountOverride = null){

    const myToken = token || ++currentIconLoadToken;

    const iconConfig = {
      ...IMPRINTLY.iconDefaults,
      ...(IMPRINTLY.tabConfigs?.[tabId]?.iconOverrides || {})
    };
    
    const canvasWidth = fabricCanvas.getWidth();


    const iconScalePercent = iconConfig.iconScalePercent;
    const iconGapPercent = iconConfig.iconGapPercent;
    const iconMarginTopPercent = iconConfig.iconMarginTopPercent;

    const iconTargetWidth = (iconScalePercent / 100) * canvasWidth;
    const iconGapX = (iconGapPercent / 100) * canvasWidth;
    const iconMarginTop = (iconMarginTopPercent / 100) * canvasWidth;

    
    
    if (!textObject) return null;

    const $tab = $('#' + tabId);
    const $iconBlock = $tab.find('.imprintly__tab-icons');
    const iconCount = iconCountOverride ?? (parseInt($iconBlock.data('icons'), 10) || 1);


    const icons = [];

    if (iconCount === 1) {
      const input = $iconBlock.find('.imprintly__tab-icons-container input[type="radio"]:checked');
      const src = input.data('src');
      if (src) {
        showCanvasLoader("Loading icons...", null, true); // 👈 agregamos parámetro silent=true
        const img = await loadIconImage(src);
        icons.push(img);
      }
    } else if (iconCount === 2) {
      const input1 = $iconBlock.find('.imprintly__tab-icons-container--1 input[type="radio"]:checked');
      const input2 = $iconBlock.find('.imprintly__tab-icons-container--2 input[type="radio"]:checked');
      const src1 = input1.data('src');
      const src2 = input2.data('src');
      showCanvasLoader("Loading icons...", null, true); // 👈 agregamos parámetro silent=true
      if (src1) icons.push(await loadIconImage(src1));
      if (src2) icons.push(await loadIconImage(src2));
    }

    if (icons.length === 0) return textObject;

    
    // 🧽 Limpiar rotación antes de posicionar íconos
    const originalAngle = textObject.angle || 0;
    textObject.set({ angle: 0 });

    // 📐 Posicionar íconos debajo del texto sin rotación
    const spacing = 10;
    const textBottomY = textObject.top + textObject.getScaledHeight() / 2;
    const maxIconHeight = Math.max(...icons.map(i => i.getScaledHeight()));
    const iconY = textBottomY + spacing + maxIconHeight / 2;

    icons.forEach((icon, i) => {
      icon.set({
        originX: 'center',
        originY: 'center'
      });
      icon.scaleToWidth(iconTargetWidth); // ✅ escala en % del canvas

      // ✅ Medimos después de escalar
      const scaledWidth = icon.getScaledWidth();
    
      // ✅ Posicionamos con base en escalado aplicado
      icon.set({
        top: textObject.top + textObject.getScaledHeight() / 2 + iconMarginTop,
        left: textObject.left + (i - (icons.length - 1) / 2) * (scaledWidth + iconGapX)
      });
    });

    // 🧩 Agrupar texto + íconos y aplicar rotación final al grupo
    const group = new fabric.Group([textObject, ...icons], {
      left: textObject.left,
      top: textObject.top,
      originX: 'center',
      originY: 'center',
      customType: 'personalizedGroup',
      tabId: tabId
    });

    group.set({ angle: originalAngle });


    // 🔒 Aplicamos bloqueos según configuración del tab
    if (!getAllowMovementForTab(tabId)) {
      group.set({
        lockMovementX: true,
        lockMovementY: true,
        hoverCursor: 'default'
      });
    }

    if (!getAllowScalingForTab(tabId)) {
      group.set({
        lockScalingX: true,
        lockScalingY: true
      });
    }

    // 🛠️ Control visual (puntos de escalado, rotación, etc.)
    disableAllObjectControls(group, getAllowScalingForTab(tabId));

    
    /*console.log('[📐 Icon Config]', {
      iconScalePercent,
      iconTargetWidth,
      iconGapX,
      iconMarginTop
    });*/
    

    if (myToken !== currentIconLoadToken) {
      console.warn('⛔ Grupo descartado por token duplicado');

      const oldObject = getPersonalizedObject(tabId);
      if (oldObject) {
        fabricCanvas.remove(oldObject);
      }

      return null;
    }  

    hideCanvasLoader();
    return group;
  }


  
  // 🔧 Carga un ícono como objeto Fabric.js
  async function loadIconImage(src) {
    return new Promise(resolve => {
      fabric.Image.fromURL(src, (img) => {
        img.set({
          originX: 'center',
          originY: 'center',
          scaleX: 0.2,
          scaleY: 0.2,
          selectable: false,
          evented: false
        });
        resolve(img);
      }, { crossOrigin: 'anonymous' });
    });
  }
    
  


  // Quita los Checbox al cambiar de tap o cerrar el

  function resetImprintlyIconCheckboxes() {
    $('.imprintly__icon-checkbox:checked').each(function () {
      $(this).prop('checked', false).trigger('change');
    });
  }
  




  function initIconCountSwitcher(tabId) {
    const $tab = $('#' + tabId);
    const $iconWrapper = $tab.find('.imprintly__tab-icons');
    const $buttons = $tab.find('[data-icons-option]');
  
    if ($buttons.length === 0 || $iconWrapper.length === 0) return;
  
    $buttons.off('click').on('click', function () {
      const $button = $(this);
      const selected = parseInt($button.data('icons-option'), 10) || 1;
  
      // 🔁 Cambiar atributo principal
      $iconWrapper.attr('data-icons', selected);
  
      // 🔁 Activar botón visualmente
      $buttons.removeClass('active');
      $button.addClass('active');

      $tab.find('button.imprintly__tab-icons-tap.imprintly__tab-icons-tap--1').click();

      if (selected === 1) {
        $tab.find('.imprintly__tab-icons-content .imprintly__tab-icons-header.imprintly__tab-icons-header--buttons').hide();
        $tab.find('p.imprintly__tab-icons-header.imprintly__tab-icons-header--message').css('display','flex');
      }
  
      if (selected === 2) {
        $tab.find('p.imprintly__tab-icons-header.imprintly__tab-icons-header--message').hide();
        $tab.find('.imprintly__tab-icons-content .imprintly__tab-icons-header.imprintly__tab-icons-header--buttons').css('display','flex');
        $tab.find('.imprintly__tab-icons-container--1 .imprintly__tab-icon').first().find('input[type="radio"]').prop('checked', true);
        $tab.find('.imprintly__tab-icons-container--2 .imprintly__tab-icon').first().find('input[type="radio"]').prop('checked', true);
      }
      
  
      // 🔁 Redibujar canvas con nueva cantidad
      drawCanvasFromActiveTab();

      // console.log('🔁 Cambio manual de icon count:', { tabId, selected });
      // console.log('🔁 Nuevo data-icons:', $iconWrapper.attr('data-icons'));

    });
  }
  




  function resetIconCountUI(tabId) {
    const $tab = $('#' + tabId);
    const $iconWrapper = $tab.find('.imprintly__tab-icons');
    const $buttons = $tab.find('[data-icons-option]');

    $tab.find('button.imprintly__tab-icons-tap.imprintly__tab-icons-tap--1').click();
  
    // 🔁 Reset visual y atributo principal
    $iconWrapper.attr('data-icons', 1);
    $buttons.removeClass('active');
    $buttons.filter('[data-icons-option="1"]').addClass('active');
  
    // 🔁 Mostrar solo componentes de 1 ícono
    $tab.find('.imprintly__tab-icons-container--1').css('display', 'block');
    $tab.find('.imprintly__tab-icons-container--2').css('display', 'none');
  
    // 🔁 Mostrar mensaje de 1 ícono y ocultar botones
    $tab.find('p.imprintly__tab-icons-header--message').css('display', 'flex');
    $tab.find('.imprintly__tab-icons-header--buttons').hide();
  }

 

  
  
  // ======================================================
  // 🖼️ FUNCIONES PARA MANEJAR EL CANVAS CON FABRIC.JS
  // ======================================================
  
  
  
  // 🖼️ Inicializa el canvas de Fabric.js y carga la imagen del producto
  
  let fabricCanvas;
  let productImage;
  function initCanvasWithImage() {
    
    const canvasEl = document.getElementById('imprintly-canvas');
    const imageSrc = canvasEl.dataset.image;
  
    if (!fabricCanvas) {
      
      fabricCanvas = new fabric.Canvas('imprintly-canvas', {
        selection: false
      });
  
  
      fabricCanvas.on('object:scaling', function (e) { 

        // console.log('🎯 Evento object:scaling disparado - tipo:', e.target?.type, 'customType:', e.target?.customType);

        const obj = e.target;
        const validTypes = Object.values(IMPRINTLY.canvasTypes);
        if (!obj || !validTypes.includes(obj.customType)) return;

        // (1) Marca que el usuario escaló manualmente este objeto
        obj.userScaled = true;

        // (2) Mantén tu lógica existente (movimientoBounds, customScaledWidth, etc.)
        const canvasWidth = fabricCanvas.getWidth();
        const canvasHeight = fabricCanvas.getHeight();
      
        // Limitar el ancho dentro de min/max permitido
        const { tabId } = getActiveTabValues();

        const alias = IMPRINTLY.tabConfigs[tabId]?.alias || '';



        const { minWidth, maxWidth } = getCanvasWidthLimits(canvasWidth, tabId);
        const currentWidth = obj.getScaledWidth();

        if (alias === 'ICON') {
          const clampedWidth = Math.min(Math.max(currentWidth, minWidth), maxWidth);
          const scaleFactor = clampedWidth / currentWidth;

          obj.scaleX *= scaleFactor;
          obj.scaleY *= scaleFactor;

          /*console.log('🔒 ICON escalado limitado manualmente:');
          console.log(' - width original:', currentWidth);
          console.log(' - width ajustado:', obj.getScaledWidth());
          console.log(' - scaleX final:', obj.scaleX);
          console.log(' - scaleY final:', obj.scaleY);*/
        } else {
          applyCanvasWidthLimits(obj, canvasWidth, tabId);
        }

        // Restricción visual de área de movimiento
        const bounds = IMPRINTLY.movementBounds;
      
        const minLeft = (bounds.leftPercent / 100) * canvasWidth;
        const maxRight = (bounds.rightPercent / 100) * canvasWidth;
        const minTop = (bounds.topPercent / 100) * canvasHeight;
        const maxBottom = (bounds.bottomPercent / 100) * canvasHeight;
      
        const halfWidth = obj.getScaledWidth() / 2;
        const halfHeight = obj.getScaledHeight() / 2;
      
        const objLeft = obj.left;
        const objTop = obj.top;
      
        const exceedsLeft   = objLeft - halfWidth < minLeft;
        const exceedsRight  = objLeft + halfWidth > maxRight;
        const exceedsTop    = objTop - halfHeight < minTop;
        const exceedsBottom = objTop + halfHeight > maxBottom;
      
        if (exceedsLeft || exceedsRight || exceedsTop || exceedsBottom) {
          // ⚠️ Si se sale del área, revertimos escala
          obj.scaleX = obj._lastValidScaleX || obj.scaleX;
          obj.scaleY = obj._lastValidScaleY || obj.scaleY;
        } else {
          // ✅ Guardamos escala válida
          obj._lastValidScaleX = obj.scaleX;
          obj._lastValidScaleY = obj.scaleY;
        }
      
        showMovementMask();
        obj.customScaledWidth = obj.getScaledWidth();
        finalizeObjectUpdate(obj, tabId);

        /*console.log('🛠️ [scaling] user está escalando', {
          width: obj.getScaledWidth(),
          tabId: tabId,
          userScaled: obj.userScaled,
          customScaledWidth: obj.customScaledWidth
        });*/        

      });
  
  
      fabricCanvas.on('object:moving', function (e) {
        const obj = e.target;
        const validTypes = Object.values(IMPRINTLY.canvasTypes);
        if (!obj || !validTypes.includes(obj.customType)) return;

        const { tabId } = getActiveTabValues();
        const alias = IMPRINTLY.tabConfigs[tabId]?.alias;

        if (alias === 'ICON') {
          lastCustomIconPosition = {
            left: obj.left,
            top: obj.top
          };
        }
      
        enforceMovementBounds(obj);
        showMovementMask();
      });
  
      fabricCanvas.on('mouse:up', function () {
        hideMovementMask();
      });
  
    }
  
    if (productImage) {
      resizeCanvasToFitContainer();
      resetCanvasTextPosition();
      return;
    }
  
    fabric.Image.fromURL(imageSrc, function (img) {
      img.set({
        selectable: false,
        evented: false
      });enforceMovementBounds
  
      productImage = img;
      fabricCanvas.add(img);
      fabricCanvas.sendToBack(img);
      resizeCanvasToFitContainer();
      drawCanvasFromActiveTab();
    }, { crossOrigin: 'anonymous' });
  }
  
  
  
  // 📐 Ajusta el tamaño del canvas al ancho del contenedor
  
  function resizeCanvasToFitContainer() {
    const canvasEl = document.getElementById('imprintly-canvas');
    const container = canvasEl.closest('.imprintly__canva');
    const containerWidth = container.clientWidth;
  
    if (!fabricCanvas || !productImage) return;
  
    const scale = containerWidth / productImage.width;
    const scaledHeight = productImage.height * scale;
  
    fabricCanvas.setWidth(containerWidth);
    fabricCanvas.setHeight(scaledHeight);
  
    productImage.set({
      scaleX: scale,
      scaleY: scale,
      left: 0,
      top: 0
    });
  
    fabricCanvas.requestRenderAll();
  
    const wrapper = canvasEl.closest('.canvas-container');
    if (wrapper) {
      wrapper.style.width = containerWidth + 'px';
      wrapper.style.height = scaledHeight + 'px';
      canvasEl.style.width = containerWidth + 'px';
      canvasEl.style.height = scaledHeight + 'px';
    }
  
    resetCanvasTextPosition();
    limitTextWidthIfNeeded();
    
  }
  
  
  
  // ✏️ Dibuja el texto en el canvas según el tab activo
  
  async function drawCanvasFromActiveTab() {
  
    if (!fabricCanvas) return;
  
    const { tabId, text, fontName, hexColor } = getActiveTabValues();

    const myToken = ++currentIconLoadToken;
  
    const existingObject = getPersonalizedObject();
    let prevPosition = null;
    let prevWidth = null;

    if (existingObject) {
      prevPosition = {
        left: existingObject.left,
        top: existingObject.top
      };
      prevWidth = existingObject.getScaledWidth();
    
      const activeTabId = getActiveTabValues().tabId;
      if (existingObject.tabId !== activeTabId) {
        delete existingObject.customScaledWidth;
      }
    
      fabricCanvas.remove(existingObject);
    }

    /*console.log('🔍 existingObject', existingObject);
    console.log('🔍 userScaled?', existingObject?.userScaled);
    console.log('🔍 customScaledWidth?', existingObject?.customScaledWidth);*/
    
  
    const canvasWidth = fabricCanvas.getWidth();
    const canvasHeight = fabricCanvas.getHeight();

    const scalingMode = getScalingModeForTab(tabId);
    const useBoxWidth = scalingMode === 'fit-box';
    const { x, y, boxWidth, fontSize, rotation } = getObjectPositionAndScaleFromTab($('#' + tabId), canvasWidth, canvasHeight, useBoxWidth);
    const adjustedFontSize = adjustFontSizeByCharCount(tabId, text, fontSize, fontName, scalingMode);


    const alias = IMPRINTLY.tabConfigs[tabId]?.alias || '';
    const isMonogram = alias === 'MONOGRAM';
    const isInitials = alias === 'INITIALS';
    const isName = alias === 'NAME';
    const isIcon = alias === 'ICON';

    let newObject = null;

    if (isMonogram) {
      newObject = createMonogramGroup(text, {
        left: x,
        top: y,
        fontFamily: fontName,
        fill: hexColor,
        fontSize: adjustedFontSize,
        angle: rotation
      }, tabId);
    } else if (isInitials) {
      newObject = createInitialsGroup(text, {
        left: x,
        top: y,
        fontFamily: fontName,
        fill: hexColor,
        fontSize: adjustedFontSize,
        angle: rotation
      }, tabId);
    } else if (isName) {
      newObject = createNameTextObject(text, {
        left: x,
        top: y,
        fontFamily: fontName,
        fill: hexColor,
        fontSize: adjustedFontSize,
        angle: rotation
      }, tabId);
    } else if (isIcon) {

      let previousPosition = lastCustomIconPosition || (existingObject && {
        left: existingObject.left,
        top: existingObject.top
      });
      
      // showCanvasLoader("Loading icon...", previousPosition);


      /*const iconPromise = createIconImageObject(tabId);
      const delayPromise = new Promise(resolve => setTimeout(resolve, 400)); // mínimo 400ms visibles
      const [iconObject] = await Promise.all([iconPromise, delayPromise]);*/

      const iconObject = await createIconImageObject(tabId);


      if (myToken !== currentIconLoadToken) {
        console.warn('⏭️ Cancelado: se seleccionó un ícono más reciente');
        return;
      }

      // 🛑 Cancelar si ya no estamos en el mismo tab
      const currentTabIdStillActive = getActiveTabValues().tabId === tabId;
      if (!currentTabIdStillActive) {
        console.warn('🚫 Cancelado: se cambió de tab durante la carga del ícono');
        // hideCanvasLoader();
        return;
      }

      // 🛑 Cancelar si el modal fue cerrado
      const modalOpen = $('#imprintly').is(':visible');
      if (!modalOpen) {
        console.warn('🚫 Cancelado: el modal fue cerrado durante la carga del ícono');
        // hideCanvasLoader();
        return;
      }


      // hideCanvasLoader();

      if (scalingMode === 'fit-box') {
        const tabElement = $('#' + tabId);
        const { boxWidth } = getObjectPositionAndScaleFromTab(tabElement, canvasWidth, canvasHeight, true);
        iconObject.scaleToWidth(boxWidth); // ✅ forzamos aquí de nuevo
      }

      newObject = iconObject;

      if (!isNaN(rotation)) {
        iconObject.set({ angle: rotation });
      }      
    }



    if (isMonogram || isInitials || isName) {

      const $checkbox = $('#' + tabId).find('.imprintly__icon-checkbox');
      const checkboxActivo = $checkbox.length && $checkbox.is(':checked');

      if (checkboxActivo) {
        const iconCount = parseInt($('#' + tabId).find('.imprintly__tab-icons').attr('data-icons'), 10) || 1;
        const groupWithIcons = await createTextWithIconGroup(newObject, tabId, myToken, iconCount);
        if (groupWithIcons) {
          newObject = groupWithIcons;
        }
      }
      

    }
    

    
    if (!newObject) return;
  
    const activeTabId = getActiveTabValues().tabId;
    const sameTab = existingObject?.tabId === activeTabId;

    const wasUserScaled = existingObject?.userScaled;
    const savedWidth = existingObject?.customScaledWidth;

    /*console.log('🟠 Tab:', tabId);
    console.log('🟠 Escalado anterior: userScaled?', wasUserScaled, ' savedWidth:', savedWidth);
    console.log('🟠 scalingMode:', scalingMode);*/

    if (wasUserScaled && savedWidth && scalingMode === 'fit-box') {
      // console.log('✅ Aplicando tamaño personalizado guardado (solo fit-box):', savedWidth);
      newObject.scaleToWidth(savedWidth);
      newObject.customScaledWidth = savedWidth;
      newObject.userScaled = true;
    } else if (scalingMode === 'fit-box') {
      // console.log('📦 Aplicando tamaño por boxWidth:', boxWidth);
      newObject.scaleToWidth(boxWidth);
    }
    


    const currentWidth = newObject.getScaledWidth();

    // console.log('📐 scaleX final:', newObject.scaleX);
    // console.log('📐 width final:', newObject.getScaledWidth());

    applyCanvasWidthLimits(newObject, canvasWidth, tabId);

    const allowMovement = getAllowMovementForTab(tabId);
    if (allowMovement && prevPosition) {
      newObject.set({
        left: prevPosition.left,
        top: prevPosition.top
      });
    }

    newObject.tabId = tabId; // 🔁 Esto permite que 'sameTab' funcione correctamente

    if (myToken !== currentIconLoadToken) {
      console.warn('⛔ Cancelado: token inválido justo antes de agregar al canvas');
      return;
    }
    
  
    fabricCanvas.add(newObject);

    newObject.tabId = tabId;
    if (wasUserScaled && savedWidth && scalingMode === 'auto-width') {
      // console.log('✅ Restaurando tamaño personalizado para auto-width (forzando escalado):', savedWidth);
      newObject.scaleToWidth(savedWidth); // 🛠️ ← Esto es lo que faltaba
      newObject.customScaledWidth = savedWidth;
      newObject.userScaled = true;
    }



    if (!isIcon) {
      setTimeout(() => {
        initIconTabSwitching(tabId);
        initIconCountSwitcher(tabId); // ✅ nuevo
      }, 50);
    }
    
    

    fabricCanvas.setActiveObject(newObject);
    fabricCanvas.bringToFront(newObject);
    finalizeObjectUpdate(newObject, tabId);

    // console.log('✅ drawCanvasFromActiveTab completado para:', tabId);

  }
  
  
  
  // 🔁 Restaura posición y tamaño del texto a valores por defecto
  
  function resetCanvasTextPosition() {
    const textObject = getPersonalizedObject();
    if (!textObject) return;
  
    const { tabId, text, fontName } = getActiveTabValues();
    const canvasWidth = fabricCanvas.getWidth();
    const canvasHeight = fabricCanvas.getHeight();

    const scalingMode = getScalingModeForTab(tabId);
    const useBoxWidth = scalingMode === 'fit-box';

    const { x, y, boxWidth, fontSize } = getObjectPositionAndScaleFromTab($('#' + tabId), canvasWidth, canvasHeight, useBoxWidth);
    const adjustedFontSize = adjustFontSizeByCharCount(tabId, text, fontSize, fontName, scalingMode);
  
    textObject.set({
      left: x,
      top: y,
      fontSize: adjustedFontSize
    });

    if (scalingMode === 'fit-box') {
      const currentWidth = textObject.getScaledWidth();
      if (Math.abs(currentWidth - boxWidth) > 1) {
        textObject.scaleToWidth(boxWidth);
      }
    } else {
      enforceAutoWidthLimits(textObject, canvasWidth);
    }
  
    finalizeObjectUpdate(textObject, tabId);
  
  }
  
  
  
  // ⛔ Limita el ancho del texto dentro de un rango permitido
  
  function limitTextWidthIfNeeded() {
    const textObj = getPersonalizedObject();
    if (!textObj) return;
  
    const canvasWidth = fabricCanvas.getWidth();
    const { tabId } = getActiveTabValues();
  
    const { minPercent, maxPercent, tolerance } = IMPRINTLY.canvasLimits;
    const { minWidth, maxWidth } = getCanvasWidthLimits(canvasWidth, tabId);
  
    const currentWidth = textObj.getScaledWidth();

    applyCanvasWidthLimits(textObj, canvasWidth, tabId);
  
    finalizeObjectUpdate(textObj, tabId);
  }
  
  
  
  // 🎨 Cambia el color del borde del texto si está en los límites
  
  function updateTextBorderColor(textObj, tabId) {
    const canvasWidth = fabricCanvas.getWidth();
    const { minPercent, maxPercent, tolerance } = getCanvasLimitsForTab(tabId);
    const { default: defaultColor, alert: alertColor } = IMPRINTLY.borderColors;
  
    const minWidth = (minPercent / 100) * canvasWidth;
    const maxWidth = (maxPercent / 100) * canvasWidth;
    const currentWidth = textObj.getScaledWidth();

    const allowMovement = getAllowMovementForTab(tabId);
    if (!allowMovement) {
      textObj.set({
        borderColor: 'transparent',
        cornerColor: 'transparent'
      });
      return;
    }
  
    const isNearLimit =
      Math.abs(currentWidth - minWidth) < tolerance ||
      Math.abs(currentWidth - maxWidth) < tolerance;

  }
  
  
  
  // ✅ Finaliza actualización del objeto: actualiza bordes, coordenadas y renderiza canvas
  
  function finalizeObjectUpdate(obj, tabId) {
    updateTextBorderColor(obj, tabId);
    enforceMovementBounds(obj);
    obj.setCoords();
    fabricCanvas.requestRenderAll();
  }
  
  
  
  // 🔒 Restringe el movimiento del objeto dentro de una zona delimitada (% canvas)
  
  function enforceMovementBounds(obj) {
    const canvasWidth = fabricCanvas.getWidth();
    const canvasHeight = fabricCanvas.getHeight();
  
    const bounds = IMPRINTLY.movementBounds;
  
    const minLeft = (bounds.leftPercent / 100) * canvasWidth;
    const maxRight = (bounds.rightPercent / 100) * canvasWidth;
    const minTop = (bounds.topPercent / 100) * canvasHeight;
    const maxBottom = (bounds.bottomPercent / 100) * canvasHeight;
  
    const objWidth = obj.getScaledWidth();
    const objHeight = obj.getScaledHeight();
  
    // En lugar de limitar el centro, limitamos los bordes reales
    let newLeft = obj.left;
    let newTop = obj.top;
  
    const halfWidth = objWidth / 2;
    const halfHeight = objHeight / 2;
  
    if (obj.left - halfWidth < minLeft) {
      newLeft = minLeft + halfWidth;
    }
    if (obj.left + halfWidth > maxRight) {
      newLeft = maxRight - halfWidth;
    }
    if (obj.top - halfHeight < minTop) {
      newTop = minTop + halfHeight;
    }
    if (obj.top + halfHeight > maxBottom) {
      newTop = maxBottom - halfHeight;
    }
  
    obj.set({
      left: newLeft,
      top: newTop
    });
  
    obj.setCoords();
  }
  
  
  
  // 🧭 Dibuja un borde decorativo que indica la zona permitida para mover el objeto
  
  function drawMovementBoundsGuide() {
    const canvasWidth = fabricCanvas.getWidth();
    const canvasHeight = fabricCanvas.getHeight();
  
    const bounds = IMPRINTLY.movementBounds;
  
    const left = (bounds.leftPercent / 100) * canvasWidth;
    const top = (bounds.topPercent / 100) * canvasHeight;
    const width = ((bounds.rightPercent - bounds.leftPercent) / 100) * canvasWidth;
    const height = ((bounds.bottomPercent - bounds.topPercent) / 100) * canvasHeight;
  
    const existing = fabricCanvas.getObjects().find(obj => obj.name === 'bounds-guide');
    if (existing) {
      fabricCanvas.remove(existing);
    }
  
    const borderRect = new fabric.Rect({
      left,
      top,
      width,
      height,
      stroke: '#ffffff',
      strokeWidth: 1,
      fill: 'transparent',
      selectable: false,
      evented: false,
      name: 'bounds-guide',
      hoverCursor: 'default'
    });
  
    fabricCanvas.add(borderRect);
    fabricCanvas.sendToBack(borderRect);
    fabricCanvas.sendToBack(productImage);
    fabricCanvas.requestRenderAll();
  }
  
  
  
  // 🌫️ Muestra una máscara visual fuera de los límites permitidos (zonas opacas)
  
  function showMovementMask() {
    hideMovementMask();
    drawMovementBoundsGuide();
  
    const canvasWidth = fabricCanvas.getWidth();
    const canvasHeight = fabricCanvas.getHeight();
    const bounds = IMPRINTLY.movementBounds;
  
    const left = (bounds.leftPercent / 100) * canvasWidth;
    const top = (bounds.topPercent / 100) * canvasHeight;
    const right = (bounds.rightPercent / 100) * canvasWidth;
    const bottom = (bounds.bottomPercent / 100) * canvasHeight;
  
    const masks = [
      // Superior
      new fabric.Rect({
        left: 0,
        top: 0,
        width: canvasWidth,
        height: top,
        fill: 'rgba(0,0,0,0.3)',
        selectable: false,
        evented: false
      }),
      // Inferior
      new fabric.Rect({
        left: 0,
        top: bottom,
        width: canvasWidth,
        height: canvasHeight - bottom,
        fill: 'rgba(0,0,0,0.3)',
        selectable: false,
        evented: false
      }),
      // Izquierda
      new fabric.Rect({
        left: 0,
        top: top,
        width: left,
        height: bottom - top,
        fill: 'rgba(0,0,0,0.3)',
        selectable: false,
        evented: false
      }),
      // Derecha
      new fabric.Rect({
        left: right,
        top: top,
        width: canvasWidth - right,
        height: bottom - top,
        fill: 'rgba(0,0,0,0.3)',
        selectable: false,
        evented: false
      })
    ];
  
    const maskGroup = new fabric.Group(masks, {
      name: 'bounds-mask',
      selectable: false,
      evented: false
    });
  
    fabricCanvas.add(maskGroup);
    fabricCanvas.bringToFront(maskGroup);
    fabricCanvas.requestRenderAll();
  }
  
  
  
  // 🧽 Elimina la máscara visual fuera de los límites
  
  function hideMovementMask() {
    const elementsToRemove = fabricCanvas.getObjects().filter(obj =>
      obj.name === 'bounds-mask' || obj.name === 'bounds-guide'
    );
    elementsToRemove.forEach(obj => fabricCanvas.remove(obj));
    fabricCanvas.requestRenderAll();
  }
  


  // 👉 Función para cargar SVG correctamente

  function showCanvasLoader(text = "Cargando...", position = null, silent = false) {
    const canvasEl = document.getElementById('imprintly-canvas');
    const wrapper = canvasEl.closest('.canvas-container');
    if (!wrapper) return;
  
    let loader = wrapper.querySelector('.canvas-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'canvas-loader';
      loader.style.position = 'absolute';
      loader.style.padding = '8px 16px';
      loader.style.background = 'rgba(0, 0, 0, 0.6)';
      loader.style.color = '#fff';
      loader.style.borderRadius = '8px';
      loader.style.zIndex = '10';
      loader.style.fontSize = '14px';
      loader.style.pointerEvents = 'none';
      wrapper.appendChild(loader);
    }

    if (silent) {
      loader.style.display = 'none'; // 👈 oculta visualmente
      return;
    }
  
    loader.textContent = text;
  
    const canvasRect = wrapper.getBoundingClientRect();
    const zoom = fabricCanvas.getZoom();
    const isMobile = window.matchMedia('(max-width: 800px)').matches;
  
    if (position) {
      const left = canvasRect.left + position.left * zoom;
      const top = canvasRect.top + position.top * zoom;
  
      loader.style.left = `${left}px`;
      loader.style.top = `${top}px`;
      loader.style.transform = isMobile ? 'translate(-50%, -50%)' : 'translate(-60%, -100%)';
  
      // ✅ Guardamos última posición válida
      lastLoaderScreenPosition = { left, top, isMobile };
    } else if (lastLoaderScreenPosition) {
      // ✅ Reutilizamos posición anterior si existe
      loader.style.left = `${lastLoaderScreenPosition.left}px`;
      loader.style.top = `${lastLoaderScreenPosition.top}px`;
      loader.style.transform = lastLoaderScreenPosition.isMobile
        ? 'translate(-50%, -50%)'
        : 'translate(-60%, -100%)';
    } else {
      // 🟡 Fallback centrado absoluto si no hay datos
      loader.style.left = '50%';
      loader.style.top = '50%';
      loader.style.transform = 'translate(-50%, -50%)';
    }
  
    loader.style.display = 'block';
  }
  
  
  
  function hideCanvasLoader() {
    const canvasEl = document.getElementById('imprintly-canvas');
    const wrapper = canvasEl.closest('.canvas-container');
    if (!wrapper) return;
  
    const loader = wrapper.querySelector('.canvas-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }
  
  
  
  
  
  // ======================================================
  // 🧩 EVENTOS DE UI Y GESTIÓN DE INPUTS / TABS
  // ======================================================
  
  
  
  // 🎯 Inicializa los eventos del modal: inputs de texto, selección de font/color y tabs
  
  let canvasEventsInitialized = false;
  function setupCanvasEvents() {
  
    if (canvasEventsInitialized) return;
    canvasEventsInitialized = true;
    
    $('.imprintly__details').on('input', 'input[type="text"]', () => {
      drawCanvasFromActiveTab();
      validateImprintlyInput();
      limitTextWidthIfNeeded(); 
      hideImprintlyAlert();
    });
  
    
    $('.imprintly__details').on('change', 'input[type="radio"]', (e) => {
      drawCanvasFromActiveTab();
      updateColorLabelText();
    
      const $input = $(e.target);
      const isFontInput = $input.closest('.imprintly__tab-font').length > 0;
    
      if (isFontInput) {
        limitTextWidthIfNeeded();
      }
    });
  
  
    $('.imprintly__nav-button').on('click', function () {
      hideCanvasLoader(); // ✅ Oculta loader al cambiar de tab
      const targetTab = $(this).data('tab');
      $('.imprintly__nav-button').removeClass('imprintly__nav-button--active');
      $(this).addClass('imprintly__nav-button--active');
      $('.imprintly__tab').removeClass('imprintly__tab--active');
      $('#' + targetTab).addClass('imprintly__tab--active');

      resetImprintlyIconCheckboxes();
      resetIconCountUI(targetTab);
      hideImprintlyAlert();
      updateImprintlyPrice();
      resetImprintlyTabs();
      limitTextWidthIfNeeded();
    });
  
  };
  
  
  
  // ♻️ Reinicia los valores de los tabs al abrir el modal: inputs, fuente y color por defecto
  
  function resetImprintlyTabs() {
    
    $('.imprintly__tab').each(function () {
      const $tab = $(this);
  
      const $input = $tab.find('input[type="text"]');
      const defaultText = $input.attr('placeholder') || '';
      $input.val('');
  
      const $fonts = $tab.find('.imprintly__tab-font input[type="radio"]');
      $fonts.prop('checked', false);
      ($fonts.filter('[data-default="true"]').length
        ? $fonts.filter('[data-default="true"]')
        : $fonts.first()
      ).prop('checked', true);
  
      const $colors = $tab.find('.imprintly__tab-color input[type="radio"]');
      $colors.prop('checked', false);
      ($colors.filter('[data-default="true"]').length
        ? $colors.filter('[data-default="true"]')
        : $colors.first()
      ).prop('checked', true);
    });
  
    drawCanvasFromActiveTab();
  }
  
  
  
  
  
  // ======================================================
  // ✍️ RENDERIZADO PERSONALIZADO POR TIPO (NAME / MONOGRAM / INITIALS)
  // ======================================================
  
  
  
  // -------- MONOGRAM --------
  
  // ➕ Crea un grupo Monogram con espaciado proporcional y armonioso
  
  function createMonogramGroup(text, options = {}, tabId = null) {
    const letters = text.toUpperCase().split('').slice(0, 3); // Solo 3 letras máx.
    if (letters.length === 0) return null;
  
    const smallScale = 0.7; // Escala para letras laterales
    const baseSpacing = 0;  // Espaciado base entre letras (px)
  
    const baseOptions = {
      fontFamily: options.fontFamily || IMPRINTLY.defaults.font,
      fill: options.fill || '#000000',
      originY: 'center',
      selectable: true,
      evented: true
    };
  
    const fontSize = options.fontSize || 40;
    const sideFontSize = fontSize * smallScale;
  
    // Crear objetos temporales para calcular anchos
    const tempObjects = letters.map((letter, index) => {
      const isCenter = (letters.length === 1) || (letters.length === 3 && index === 1);
      const letterFontSize = isCenter ? fontSize : sideFontSize;
  
      return new fabric.Text(letter, {
        ...baseOptions,
        fontSize: letterFontSize
      });
    });
  
    // Calcular posición relativa de cada letra
    const totalWidth =
      tempObjects.reduce((sum, obj) => sum + obj.width, 0) +
      (tempObjects.length - 1) * baseSpacing;
  
    let currentX = -totalWidth / 2;
  
    tempObjects.forEach((obj, i) => {
      obj.set({
        originX: 'left',
        left: currentX
      });
  
      currentX += obj.width + baseSpacing;
    });
  
    const group = new fabric.Group(tempObjects, {
      left: options.left || 0,
      top: options.top || 0,
      angle: options.angle || 0,
      originX: 'center',
      originY: 'center',
      customType: 'personalizedGroup',
      hasControls: true,
      hasBorders: true,
      lockRotation: true,
      lockScalingFlip: true,
      lockUniScaling: false,
      cornerSize: 10,
      cornerStyle: 'circle'
    });

    if (tabId && !getAllowScalingForTab(tabId)) {
      group.set({
        lockScalingX: true,
        lockScalingY: true
      });
    }

    if (tabId && !getAllowMovementForTab(tabId)) {
      group.set({
        lockMovementX: true,
        lockMovementY: true,
        hoverCursor: 'default'
      });
    }
    
  
    disableAllObjectControls(group, getAllowScalingForTab(tabId));
  
    return group;
  }
  
  
  
  // -------- INITIALS --------
  
  // ➕ Crea un grupo Initials con espaciado proporcional y armonioso
  
  function createInitialsGroup(text, options = {}, tabId = null) {
    const letters = text.toUpperCase().slice(0, 2);
    if (letters.length === 0) return null;
  
    const fontSize = options.fontSize || 40;
    const fontName = options.fontFamily || IMPRINTLY.defaults.font;
  
    let spacing = fontSize * 0.15;
    let lineWidth = fontSize * 0.04;
    let lineHeight = fontSize * 1.3;
    let verticalAdjustment = fontSize * 0.11;
  
    const customFontAdjustments = {
      'Athletic':    { lineHeight: 1.5, verticalAdjustment: 0.15 },
      'Times':       { lineWidth: 0.05, lineHeight: 1.2, verticalAdjustment: 0.05 },
      'Contour':     { lineHeight: 1.2, verticalAdjustment: 0.05 },
      'Endevor':     { lineWidth: 0.04, lineHeight: 1.2, verticalAdjustment: 0.05 },
      'Felt Tip':     { lineWidth: 0.04, lineHeight: 1.2, verticalAdjustment: 0.05 },
      'Type':     { lineHeight: 1.2, verticalAdjustment: 0.03 },
      'Roman':     { lineHeight: 1.2, verticalAdjustment: 0.05 }
    };
  
    if (customFontAdjustments[fontName]) {
      const custom = customFontAdjustments[fontName];
      if (custom.spacing !== undefined) spacing = fontSize * custom.spacing;
      if (custom.lineWidth !== undefined) lineWidth = fontSize * custom.lineWidth;
      if (custom.lineHeight !== undefined) lineHeight = fontSize * custom.lineHeight;
      if (custom.verticalAdjustment !== undefined) verticalAdjustment = fontSize * custom.verticalAdjustment;
    }
  
    
  
    const baseOptions = {
      fontFamily: options.fontFamily || IMPRINTLY.defaults.font,
      fill: options.fill || '#000000',
      originY: 'center',
      selectable: true,
      evented: true
    };
  
    const leftLetter = new fabric.Text(letters[0], {
      ...baseOptions,
      fontSize,
      originX: 'right'
    });
  
    const rightLetter = new fabric.Text(letters[1] || '', {
      ...baseOptions,
      fontSize,
      originX: 'left'
    });
  
    const verticalLine = new fabric.Rect({
      width: lineWidth,
      height: lineHeight,
      fill: baseOptions.fill,
      originX: 'center',
      originY: 'center',
      selectable: false,
      evented: false,
      rx: lineWidth / 4,
      ry: lineWidth / 4,
      opacity: 1
    });
  
    // ✅ Ajuste visual fijo
    verticalLine.set({ top: -verticalAdjustment });
  
    // 📐 Posicionamiento horizontal
    leftLetter.set({ left: -(spacing + lineWidth / 2) });
    verticalLine.set({ left: 0 });
    rightLetter.set({ left: spacing + lineWidth / 2 });
  
    const group = new fabric.Group([leftLetter, verticalLine, rightLetter], {
      left: options.left || 0,
      top: options.top || 0,
      angle: options.angle || 0,
      originX: 'center',
      originY: 'center',
      customType: 'personalizedGroup',
      hasControls: true,
      hasBorders: true,
      lockRotation: true,
      lockScalingFlip: true,
      lockUniScaling: false,
      cornerSize: 10,
      cornerStyle: 'circle'
    });

    if (tabId && !getAllowScalingForTab(tabId)) {
      group.set({
        lockScalingX: true,
        lockScalingY: true,
      });
    }

    if (tabId && !getAllowMovementForTab(tabId)) {
      group.set({
        lockMovementX: true,
        lockMovementY: true,
        hoverCursor: 'default'
      });
    }
    
  
    disableAllObjectControls(group, getAllowScalingForTab(tabId));
  
    return group;
  }
  
  
  
  // -------- NAME ------------
  
  // ➕ Crea un objeto de texto para el tipo Name (estilo clásico, sin separadores)
  
  function createNameTextObject(text, options = {}, tabId = null) {
    const textObj = new fabric.Text(text, {
      ...options,
      originX: 'center',
      originY: 'center',
      selectable: true,
      evented: true,
      hasControls: true,
      hasBorders: true,
      lockRotation: true,
      lockScalingFlip: true,
      lockUniScaling: false,
      lockScalingX: false,
      lockScalingY: false,
      cornerSize: 10,
      cornerStyle: 'circle',
      customType: 'personalizedText'
    });

    if (tabId && !getAllowScalingForTab(tabId)) {
      textObj.set({
        lockScalingX: true,
        lockScalingY: true
      });
    }

    if (tabId && !getAllowMovementForTab(tabId)) {
      textObj.set({
        lockMovementX: true,
        lockMovementY: true,
        hoverCursor: 'default'
      });
    }
  
    disableAllObjectControls(textObj, getAllowScalingForTab(tabId));
  
    return textObj;
  }



  // -------- ICON IMAGE --------

  // 🧩 Crea un objeto de imagen escalado y centrado para el tab ICON

  async function createIconImageObject(tabId) {
    return new Promise((resolve, reject) => {
      const selectedInput = document.querySelector('input[name="imprintly-icons"]:checked');
      if (!selectedInput) return reject('No icon selected');
  
      const imageUrl = selectedInput.dataset.src;
      if (!imageUrl) return reject('Icon does not have a valid data-src');
  
      const canvasWidth = fabricCanvas.getWidth();
      const canvasHeight = fabricCanvas.getHeight();
  
      const tabElement = document.querySelector(`#${tabId}`);
      if (!tabElement) return reject('Tab element not found');
  
      const $tab = $(tabElement);
  
      // ✅ Necesitamos el boxWidth aquí
      const { x, y, boxWidth } = getObjectPositionAndScaleFromTab($tab, canvasWidth, canvasHeight, true);
  
      fabric.Image.fromURL(imageUrl, (img) => {
        const scalingMode = getScalingModeForTab(tabId);
        let scale = 1;
  
        if (scalingMode === 'fit-box') {
          const scaleX = boxWidth / img.width;
          const scaleY = boxWidth / img.height;
          scale = Math.min(scaleX, scaleY);
        } else {
          const canvasLimits = getCanvasLimitsForTab(tabId);
          const targetWidth = (canvasLimits.maxPercent / 100) * canvasWidth;
          scale = targetWidth / img.width;
        }
  
        img.set({
          left: x,
          top: y,
          angle: parseFloat($tab.data('rotation')) || 0,
          scaleX: scale,
          scaleY: scale,
          originX: 'center',
          originY: 'center',
          hasBorders: true,
          hasControls: getAllowScalingForTab(tabId),
          lockRotation: true,
          lockScalingFlip: true,
          centeredScaling: true,
          cornerSize: 10,
          cornerStyle: 'circle',
          customType: IMPRINTLY.canvasTypes.GROUP || 'personalizedGroup'
        });
  
        if (!getAllowScalingForTab(tabId)) {
          img.set({
            lockScalingX: true,
            lockScalingY: true
          });
        }

        if (tabId && !getAllowMovementForTab(tabId)) {
          img.set({
            lockMovementX: true,
            lockMovementY: true,
            hoverCursor: 'default'
          });
        }
        
  
        disableAllObjectControls(img, getAllowScalingForTab(tabId));
        resolve(img);
      }, {
        crossOrigin: 'anonymous'
      });
    });
  }



  

  // ======================================================
  // 🧪 HERRAMIENTAS DE DEPURACIÓN Y PRUEBA
  // ======================================================
  
  
  
  // 🧪 Herramienta de inspección: actualiza posición, tamaño del texto y redibuja el canvas
  
  window.setCanvasPosition = function (x, y, width, fontSizePercent) {
    const $activeTab = $('.imprintly__tab--active');
    if (x !== undefined) $activeTab.attr('data-x', x);
    if (y !== undefined) $activeTab.attr('data-y', y);
    if (width !== undefined) $activeTab.attr('data-width', width);
    if (fontSizePercent !== undefined) $activeTab.attr('data-font-size', fontSizePercent);
  
    drawCanvasFromActiveTab();
    console.log(`Canvas updated with:
    X: ${$activeTab.attr('data-x')}%
    Y: ${$activeTab.attr('data-y')}%
    Width: ${$activeTab.attr('data-width')}
    Font Size: ${$activeTab.attr('data-font-size')}%
    `);
  };








  // ======================================================
  // 🛒 FUNCIONES PARA ADD TO CART
  // ======================================================
  

  // Validación de inputs para proceder con el ADD TO CART

  function validateImprintlyTabInput(tabId) {
    const alias = IMPRINTLY.tabConfigs[tabId]?.alias;
    const $tab = $('#' + tabId);
    const $input = $tab.find('input[type="text"]');
    const value = $input.length ? $input.val().trim() : '';
  
    if (alias === 'ICON') return { valid: true };
  
    const length = value.length;
    let isValid = false;
    let message = '';
  
    switch (alias) {
      case 'MONOGRAM':
        isValid = length === 3;
        if (!isValid) message = 'Monogram must have exactly 3 letters.';
        break;
      case 'INITIALS':
        isValid = length === 2;
        if (!isValid) message = 'Initials must have exactly 2 letters.';
        break;
      case 'NAME':
        isValid = length >= 1 && length <= 6;
        if (!isValid) message = 'Name must be between 1 and 6 characters.';
        break;
    }
  
    return { valid: isValid, message };
  }






  // Función que ejecuta el ADD to CART

  $('.imprintly__call-to-action button').on('click', async function () {

    const { tabId } = getActiveTabValues();
    const { valid, message } = validateImprintlyTabInput(tabId);
  
    if (!valid) {
      $('.imprintly__call-to-action div.alert p').text(message);
      $('.imprintly__call-to-action div.alert').css('display','flex');
      $('.imprintly__call-to-action button').addClass('btn-disable');
      return;
    }

    showImprintlyLoader();
  
    // ✅ Exporta imagen en alta calidad

    const format = 'jpeg';
    const dataURL = await exportImprintlyCanvasImageHD(800, format, 0.8);
    const fileName = generateImprintlyFilename(format);

    // 🧩 Datos adicionales (puedes tomar estos desde inputs ocultos o config)

    const originalProductId = $('#imprintly').attr('data-id');
    const price = $('#imprintly').attr('data-price');
    const compareAtPrice = $('#imprintly').attr('data-compare-at-price');
    
    const payload = {
      base64: dataURL.replace(/^data:image\/\w+;base64,/, ''),
      fileName,
      mimeType: 'image/jpeg',
      originalProductId,
      price,
      compareAtPrice
    };



    // 🔍 Capturamos inputs personalizados

    const tabValues = getActiveTabValues();
    console.log('🧩 Datos del tab activo:', tabValues);

    // 🔍 Capturamos íconos seleccionados (si existen)

    const $tab = $('#' + tabValues.tabId);
    const $iconBlock = $tab.find('.imprintly__tab-icons');
    const iconCount = parseInt($iconBlock.attr('data-icons'), 10) || 1;

    let selectedIcons = [];

    if ($tab.find('.imprintly__icon-checkbox').is(':checked')) {
      if (iconCount === 1) {
        const input = $iconBlock.find('.imprintly__tab-icons-container input[type="radio"]:checked');
        selectedIcons.push({
          label: input.val(),    
          url: input.data('src') 
        });
      } else if (iconCount === 2) {
        const input1 = $iconBlock.find('.imprintly__tab-icons-container--1 input[type="radio"]:checked');
        const input2 = $iconBlock.find('.imprintly__tab-icons-container--2 input[type="radio"]:checked');
        if (input1.length) {
          selectedIcons.push({
            label: input1.val(),
            url: input1.data('src')
          });
        }
    
        if (input2.length) {
          selectedIcons.push({
            label: input2.val(),
            url: input2.data('src')
          });
        }
      }
    }


    const data = await handleAddToCartClick(payload);
    if (!data) return; // Si falló, detenemos el flujo

    tabValues.previewUrl = data.imageUrl;
    const properties = buildImprintlyProperties(tabId, tabValues, selectedIcons);




    console.log('🧾 Properties para Add to Cart:', properties);
    console.log('🚀 Enviando payload al backend:', payload);



    addToShopifyCart(data.variantId, properties);


  });
  
  
  


  function hideImprintlyAlert() {
    $('.imprintly__call-to-action div.alert p').text('');
    $('.imprintly__call-to-action div.alert').css('display','none');
    $('.imprintly__call-to-action button').removeClass('btn-disable');
  }





  // 📦 Exporta imagen centrada en canvas cuadrado de tamaño fijo (ideal para backend/Shopify)

  async function exportImprintlyCanvasImageHD(size = 800, format = 'jpeg', quality = 0.8) {
    if (!fabricCanvas) return null;
  
    const originalWidth = fabricCanvas.getWidth();
    const originalHeight = fabricCanvas.getHeight();
    const scale = Math.min(size / originalWidth, size / originalHeight);
  
    const exportCanvasEl = document.createElement('canvas');
    exportCanvasEl.width = size;
    exportCanvasEl.height = size;
  
    const exportCanvas = new fabric.StaticCanvas(exportCanvasEl, {
      backgroundColor: '#ffffff' // Fondo blanco (requerido para JPEG)
    });
  
    // Filtramos solo los objetos personalizados válidos
    const objects = fabricCanvas.getObjects().filter(obj =>
      obj.customType || obj === productImage
    );
  
    const jsonObjects = objects.map(obj =>
      obj.toObject(['customType', 'tabId', 'left', 'top', 'scaleX', 'scaleY'])
    );
  
    return new Promise((resolve) => {
      fabric.util.enlivenObjects(jsonObjects, function (enlivenedObjects) {
        enlivenedObjects.forEach(obj => {
          obj.scaleX *= scale;
          obj.scaleY *= scale;
          obj.left *= scale;
          obj.top *= scale;
          obj.setCoords();
          exportCanvas.add(obj);
        });
  
        exportCanvas.renderAll();
  
        const dataURL = exportCanvas.toDataURL({
          format: format,
          quality: quality
        });
  
        console.log('🧪 Tamaño de imagen exportada (aprox KB):', Math.round(dataURL.length * 3 / 4 / 1024));
  
        resolve(dataURL);
      });
    });
  }
  
  
  
  
  function generateImprintlyFilename(format = 'jpeg') {
    const now = new Date();
    const timestamp = now.toISOString().replace(/[-:.TZ]/g, '').slice(0, 14); // YYYYMMDDHHMMSS
    return `preview-imprintly-${timestamp}.${format}`;
  }







  async function handleAddToCartClick(payload) {
    try {
      const response = await fetch('https://imprintly-prod-app-d7c1e7dca663.herokuapp.com/api/imprintly/create-product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || 'Error en la creación del producto');
      }
  
      console.log('✅ Producto creado:', data);
  
      return data;

    } catch (error) {

      console.error('❌ Error al crear el producto:', error);
      // alert('Hubo un problema al crear tu producto personalizado.');
      showImprintlyLoaderFail();
      return null;

    }
  }
  

  



  function buildImprintlyProperties(tabId, tabValues, selectedIcons) {
    const alias = IMPRINTLY.tabConfigs[tabId]?.alias || '';
  
    const properties = {};
  
    if (alias === 'ICON') {
      const $tab = $('#' + tabId);
      const $selectedIcon = $tab.find('.imprintly__tab-font input[type="radio"]:checked');
      const label = tabValues.fontName || $selectedIcon.val();
      const url = $selectedIcon.attr('data-src') || '';
    
      properties['Customization'] = capitalize(alias);
      properties['Icon'] = `${url}`;

      if (tabValues.previewUrl) {
        properties['Preview'] = tabValues.previewUrl;
      }
    
      return properties;
    }
    
  
    // Si NO es ICON:
    properties['Customization'] = capitalize(alias);
    properties['Font'] = tabValues.fontName;
  
    const text = (alias === 'MONOGRAM' || alias === 'INITIALS') ? tabValues.text.toUpperCase() : tabValues.text;
    properties['Engraving'] = text;
  
    properties['Color'] = tabValues.colorName;

    selectedIcons.forEach((icon, index) => {
      properties[`Extra Icon ${index + 1}`] = `${icon.url}`;
    });


    if (tabValues.previewUrl) {
      properties['Preview'] = tabValues.previewUrl;
    }

    return properties;
  }


  function capitalize(word) {
    if (!word) return '';
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
  








  // 🛒 Agrega el producto personalizado al carrito

  function addToShopifyCart(variantId, properties) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        quantity: 1,
        id: variantId,
        properties: properties
      },
      success: function (item) {
        console.log('🛒 Producto agregado al carrito:', item);
        hideImprintlyLoader();
      },
      error: function (err) {
        console.error('❌ Error al agregar al carrito:', err);
        alert('No pudimos agregar tu producto personalizado al carrito.');
        showImprintlyLoaderFail();
      }
    });
  }







// ===============================
// 🔄 IMPRINTLY LOADER HANDLER
// ===============================

const loaderMessages = [
  "This may take between 10 to 20 seconds while we add your product...", 
  "We’re preparing your product…",
  "Adding your customization…",
  "Generating your preview image…",
  "Almost ready!",
  "We’ll let you know if something goes wrong..."
];

let loaderInterval = null;
let loaderTimeout = null;
let currentMessageIndex = 0;

function showImprintlyLoader() {
  $('#imprintly-loader').fadeIn();
  $('.loader').css('display','flex');
  $('.fail').hide();
  currentMessageIndex = 0;
  updateLoaderMessage();

  // Cambia el mensaje cada 3.5s
  loaderInterval = setInterval(() => {
    currentMessageIndex = (currentMessageIndex + 1) % loaderMessages.length;
    updateLoaderMessage();
  }, 3500);

  // Falla si pasan más de 20s
  loaderTimeout = setTimeout(() => {
    showImprintlyLoaderFail();
  }, 25000);
}

function hideImprintlyLoader() {
  $('#imprintly-loader').fadeOut();
  clearInterval(loaderInterval);
  clearTimeout(loaderTimeout);
}

function updateLoaderMessage() {
  const $p = $('.loader__message p');
  $p.fadeOut(250, () => {
    $p.text(loaderMessages[currentMessageIndex]).fadeIn(250);
  });
}

function showImprintlyLoaderFail() {
  clearInterval(loaderInterval);
  clearTimeout(loaderTimeout);
  $('.loader').hide();
  $('.fail').css('display','flex');
}

// Retry desde el botón de error
$(document).on('click', '.fail .close-modal', () => {
  hideImprintlyLoader();
});

// ===============================
// 🚀 USO EN FLUJO DE ADD TO CART
// ===============================

// Dentro de tu flujo actual:
// showImprintlyLoader(); // al iniciar
// hideImprintlyLoader(); // al terminar con éxito
// showImprintlyLoaderFail(); // si falla

// Ejemplo dentro de async function:
// showImprintlyLoader();
// const result = await fetch(...);
// if (success) hideImprintlyLoader();
// else showImprintlyLoaderFail();








// ===============================
// 👨🏻‍🔬 DEPURADOR OCULTAR DESPUES DE CAMBIOS
// ===============================



window.setCanvasAndShowWidth = function (x, y, width, fontSizePercent, color = '#ffffff', rotation) {
  const $activeTab = $('.imprintly__tab--active');
  if (x !== undefined) $activeTab.attr('data-x', x);
  if (y !== undefined) $activeTab.attr('data-y', y);
  if (width !== undefined) $activeTab.attr('data-width', width);
  if (fontSizePercent !== undefined) $activeTab.attr('data-font-size', fontSizePercent);

  drawCanvasFromActiveTab();

  // 💡 Esperamos a que se dibuje
  setTimeout(() => {
    const obj = getPersonalizedObject();
    if (!obj) return console.warn('⚠️ No se encontró objeto personalizado');

    if (rotation !== undefined) {
      obj.set('angle', rotation);
      obj.setCoords(); // necesario después de rotar
    }

    const canvasWidth = fabricCanvas.getWidth();
    const canvasHeight = fabricCanvas.getHeight();

    // 🔎 Obtener límites desde la configuración del tab actual
    const { tabId } = getActiveTabValues();
    const { maxPercent } = getCanvasLimitsForTab(tabId);
    const maxWidth = (maxPercent / 100) * canvasWidth;

    // 🧽 Elimina línea previa si existe
    const existingLine = fabricCanvas.getObjects().find(o => o.name === 'maxWidthLine');
    if (existingLine) fabricCanvas.remove(existingLine);

    const angleRad = (rotation || 0) * Math.PI / 180;
    const effectiveWidth = maxWidth; // ❌ no aplicar coseno


    // ➕ Línea nueva con longitud = ancho máximo permitido
    const line = new fabric.Line([
      -effectiveWidth / 2, 0,
      effectiveWidth / 2, 0
    ], {
      left: obj.left,
      top: obj.top + obj.getScaledHeight() / 2 + 10,
      angle: rotation || 0,
      originX: 'center',
      originY: 'center',
      stroke: color,
      strokeWidth: 3,
      selectable: false,
      evented: false,
      name: 'maxWidthLine'
    });    

    fabricCanvas.add(line);
    fabricCanvas.bringToFront(line);
    fabricCanvas.bringToFront(obj);

    console.log(`🎯 Posición actual:
    X: ${$activeTab.attr('data-x')}%
    Y: ${$activeTab.attr('data-y')}%
    Width: ${$activeTab.attr('data-width')}%
    Font Size: ${$activeTab.attr('data-font-size')}%
    Object Width (px): ${obj.getScaledWidth().toFixed(2)}
    Máximo permitido (px): ${maxWidth.toFixed(2)}
    `);
  }, 150);
};
